import { prepareHeadersForGlobalFilters } from "../PagesContent/Overview/CommonFunctions";
import { GetData } from "./Functions/SettingData";
import qs from "qs";
import { getBmsFaultErrorCodesHeader } from "./Functions/BmsFaultHeader";

export const getDiagnosticsBatteriesList = async (globalFilters, filters) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/batteries`,
    headers,
    params: filters,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
};

export const getBatteryAlertIncidents = async (
  globalFilters,
  batteryID,
  filters
) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/incidents/${batteryID}`,
    headers,
    params: filters,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = GetData(config);
  return data;
};

export const alertListAction = async (globalFilters, actionData) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };
  var config = {
    method: "post",
    url: `/api/diagnostics/v2/list-actions`,
    headers,
    data: actionData,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const getAlertIncidentActivityHistory = async (
  alertIncidentId,
  params = {}
) => {
  var config = {
    method: "get",
    url: `/api/diagnostics/v2/incidents/${alertIncidentId}/activity/history`,
    headers: getBmsFaultErrorCodesHeader(),
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const alertIncidentLogActivity = async (incidentId, logData) => {
  var config = {
    method: "post",
    url: `/api/diagnostics/v2/incidents/${incidentId}/activity`,
    headers: {
      "Content-Type": "application/json",
      ...getBmsFaultErrorCodesHeader(),
    },
    data: logData,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticMeta = async () => {
  var config = {
    method: "get",
    url: `/api/diagnostics/v2/meta/hvil_fault_system`,
    headers: getBmsFaultErrorCodesHeader(),
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticInfo = async (incidentId) => {
  var config = {
    method: "get",
    url: `/api/diagnostics/incident/info/${incidentId}`,
    headers: getBmsFaultErrorCodesHeader(),
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticsAnalyticsKpis = async (globalFilters, filters) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/analytics/kpis`,
    params: filters,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticsAnalyticsTimeSeries = async (
  globalFilters,
  params
) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  params.filters = JSON.stringify(params.filters);

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/analytics/timeseries`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticsAnalyticsList = async (globalFilters, params) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  params.filters = JSON.stringify(params.filters);

  var config = {
    method: "get",
    url: `/api/diagnostics/v2/analytics/list`,
    params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

export const getDiagnosticsAnalyticsListAction = async (
  globalFilters,
  params
) => {
  const headers = { ...prepareHeadersForGlobalFilters(globalFilters, 'bmsFaults'), ...getBmsFaultErrorCodesHeader() };

  params.filters = JSON.stringify(params.filters);

  var config = {
    method: "post",
    url: `/api/diagnostics/v2/analytics/list-actions`,
    data: params,
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    headers,
  };

  let data = await GetData(config);
  return data;
};

// Mock API function for BMS Faults Breakdown
export const getBmsFaultsBreakdownData = async ({
  groupBy,
  selectedItem,
  startDate,
  endDate,
  hierarchicalLocation,
  alertCategories,
}) => {
  // Mock data generation based on groupBy type
  const generateMockData = () => {
    const mockDataByType = {
      city: {
        groupByItems: [
          {
            id: "all",
            label: "All",
            count: 350,
            severityBreakdown: { warning: 22, high: 23, critical: 20 },
          },
          {
            id: "bangalore",
            label: "Bangalore",
            count: 106,
            severityBreakdown: { warning: 8, high: 10, critical: 5 },
          },
          {
            id: "mangalore",
            label: "Mangalore",
            count: 58,
            severityBreakdown: { warning: 5, high: 6, critical: 4 },
          },
          {
            id: "mumbai",
            label: "Mumbai",
            count: 58,
            severityBreakdown: { warning: 4, high: 4, critical: 6 },
          },
          {
            id: "surat",
            label: "Surat",
            count: 58,
            severityBreakdown: { warning: 3, high: 2, critical: 3 },
          },
          {
            id: "delhi",
            label: "Delhi",
            count: 58,
            severityBreakdown: { warning: 2, high: 1, critical: 2 },
          },
        ],
        chartData: [
          {
            alertName: "Battery temperature is too high",
            warning: 19,
            high: 19,
            critical: 17,
            total: 55,
          },
          {
            alertName: "The voltage difference between strings i....",
            warning: 11,
            high: 14,
            critical: 10,
            total: 35,
          },
          {
            alertName: "BMS working voltage is too high (24V pl.....",
            warning: 8,
            high: 13,
            critical: 9,
            total: 30,
          },
          {
            alertName: "Critical Low SOC",
            warning: 8,
            high: 10,
            critical: 7,
            total: 25,
          },
          {
            alertName: "Battery Data not coming",
            warning: 10,
            high: 8,
            critical: 2,
            total: 20,
          },
          {
            alertName: "Battery temperature difference is too large",
            warning: 5,
            high: 5,
            critical: 3,
            total: 13,
          },
          {
            alertName: "Alert name",
            warning: 6,
            high: 3,
            critical: 1,
            total: 10,
          },
          {
            alertName: "Alert name",
            warning: 4,
            high: 2,
            critical: 2,
            total: 8,
          },
          {
            alertName: "Alert name",
            warning: 4,
            high: 3,
            critical: 1,
            total: 8,
          },
        ],
      },
      severity: {
        groupByItems: [
          {
            id: "all",
            label: "All",
            count: 350,
            severityBreakdown: { warning: 22, high: 23, critical: 20 },
          },
          {
            id: "critical",
            label: "Critical",
            count: 120,
            severityBreakdown: { warning: 0, high: 0, critical: 120 },
          },
          {
            id: "high",
            label: "High Severity",
            count: 130,
            severityBreakdown: { warning: 0, high: 130, critical: 0 },
          },
          {
            id: "warning",
            label: "Warning",
            count: 100,
            severityBreakdown: { warning: 100, high: 0, critical: 0 },
          },
        ],
        chartData: [
          {
            alertName: "Battery temperature is too high",
            warning: 20,
            high: 15,
            critical: 15,
            total: 50,
          },
          {
            alertName: "Critical Low SOC",
            warning: 9,
            high: 18,
            critical: 18,
            total: 45,
          },
        ],
      },
      alert_type: {
        groupByItems: [
          {
            id: "all",
            label: "All",
            count: 350,
            severityBreakdown: { warning: 22, high: 23, critical: 20 },
          },
          {
            id: "temperature",
            label: "Temperature Alerts",
            count: 88,
            severityBreakdown: { warning: 10, high: 8, critical: 5 },
          },
          {
            id: "voltage",
            label: "Voltage Alerts",
            count: 65,
            severityBreakdown: { warning: 8, high: 10, critical: 8 },
          },
          {
            id: "soc",
            label: "SOC Alerts",
            count: 45,
            severityBreakdown: { warning: 4, high: 5, critical: 7 },
          },
        ],
        chartData: [
          {
            alertName: "Battery temperature is too high",
            warning: 19,
            high: 19,
            critical: 17,
            total: 55,
          },
          {
            alertName: "Battery temperature difference is too large",
            warning: 13,
            high: 13,
            critical: 7,
            total: 33,
          },
        ],
      },
      vehicle: {
        groupByItems: [
          {
            id: "all",
            label: "All",
            count: 350,
            severityBreakdown: { warning: 22, high: 23, critical: 20 },
          },
          {
            id: "vehicle1",
            label: "Vehicle ABC-123",
            count: 45,
            severityBreakdown: { warning: 5, high: 6, critical: 4 },
          },
          {
            id: "vehicle2",
            label: "Vehicle DEF-456",
            count: 38,
            severityBreakdown: { warning: 4, high: 5, critical: 3 },
          },
          {
            id: "vehicle3",
            label: "Vehicle GHI-789",
            count: 32,
            severityBreakdown: { warning: 3, high: 4, critical: 2 },
          },
        ],
        chartData: [
          {
            alertName: "Battery temperature is too high",
            warning: 9,
            high: 9,
            critical: 7,
            total: 25,
          },
          {
            alertName: "The voltage difference between strings i....",
            warning: 6,
            high: 8,
            critical: 6,
            total: 20,
          },
        ],
      },
    };

    return mockDataByType[groupBy] || mockDataByType.city;
  };

  // Simulate API delay
  await new Promise((resolve) => setTimeout(resolve, 500));

  return generateMockData();
};

export const getAlertSettingsList = async (params = {}) => {
  const config = {
    method: "get",
    url: "/api/v2/alerts",
    params,
    paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "repeat" }),
  };
  return GetData(config);
};

export const getAlertSeverityDetails = async (alertID, severityLevelID) => {
  const config = {
    method: "get",
    url: `/api/v2/alerts/${alertID}/severity/${severityLevelID}`,
  };
  return GetData(config);
};

export const getAlertSearchSuggestions = async (columnSearch, columnName, columnLimit) => {
  const config = {
    method: "get",
    url: "/api/v2/alerts/search_suggestions",
    params: { columnName, columnSearch, columnLimit },
  };
  return GetData(config);
};
